import React from 'react';
import MyGallery from "../Gallery/MyGallery";
import './ServicesPage.css';
import {useTranslation} from "react-i18next";

function ProjectsPage() {
    const { t } = useTranslation();
    const directory= "/images/projects/";
    const filenames=[
        'VPR02331_Vasso_Paraschi.webp',
        'VPR02340_Vasso_Paraschi.webp',
        'VPR02364_Vasso_Paraschi_copy.webp',
        'VPR02373_Vasso_Paraschi.webp',
        'VPR02421_Vasso_Paraschi.webp',
        'VPR02427_Vasso_Paraschi.webp',
        'VPR02436_Vasso_Paraschi.webp',
        'VPR02449_Vasso_Paraschi.webp',
        'VPR02452_Vasso_Paraschi.webp',
        'VPR02466_Vasso_Paraschi.webp',
        'VPR02476_Vasso_Paraschi.webp',
        'VPR02490_Vasso_Paraschi.webp',
        'VPR02493_Vasso_Paraschi.webp',
        'VPR02521_Vasso_Paraschi.webp',
        'VPR02523_Vasso_Paraschi.webp',
        'VPR02526_Vasso_Paraschi copy.webp',
        'VPR02532_Vasso_Paraschi.webp',
        'VPR02536_Vasso_Paraschi.webp',
        'VPR02551_Vasso_Paraschi.webp',
        'VPR02628_Vasso_Paraschi.webp',
        'VPR02630_Vasso_Paraschi.webp',
        'VPR02639_Vasso_Paraschi.webp',
        'VPR02723_Vasso_Paraschi.webp',
        'VPR02726_Vasso_Paraschi.webp',
        'VPR02735_Vasso_Paraschi.webp',
        'VPR02753_Vasso_Paraschi.webp',
        'VPR02781_Vasso_Paraschi.webp',
        'VPR02822_Vasso_Paraschi.webp',
        'VPR03246-Enhanced-NR_Vasso_Paraschi copy.webp'
    ];

    return (
        <div className="services-page">
            <h1>{t("Projects")}</h1>
            <div className="services-info-container">
                <MyGallery directory={directory} filenames={filenames} />
            </div>

        </div>
    );
}

export default ProjectsPage;
